import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "viewdisplaysettings"
    }}>{`ViewDisplaySettings`}</h1>
    <p>{`Options for display performance settings, which influence the speed and quality with which an object draws and redraws.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`HIGH_QUALITY`}</strong>{` = 1346922866`}</p>
      <p parentName="blockquote">{`Slower performance; displays high-resolution graphics and high-quality transparencies and turns on anti-aliasing.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TYPICAL`}</strong>{` = 1349810544`}</p>
      <p parentName="blockquote">{`Moderate performance speed; displays proxy graphics and low-quality transparencies and turns on anti-aliasing.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`OPTIMIZED`}</strong>{` = 1349480564`}</p>
      <p parentName="blockquote">{`Best performance; grays out graphics and turns off transparency and anti-aliasing.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      